// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cDMr","type":"styles_type__tv0Vx","choices":"styles_choices__1h0Mn"};